import React, { useRef } from 'react';

const WebSocketContext = React.createContext();

export function WebSocketProvider(props) {
  const socketRef = useRef(null);
  const listenersRef = useRef([]);

  function addListener(id, type, handler) {
    // WebSocket is intentionally disabled.
    listenersRef.current = [...listenersRef.current, { id, type, handler }];
  }

  function removeListener(id) {
    const listener = listenersRef.current?.filter((l) => l.id === id);
    listenersRef.current = listenersRef.current?.filter((l) => l.id !== id);

    if (listener && socketRef.current) {
      return;
    }
  }

  return (
    <WebSocketContext.Provider
      value={{
        addListener,
        removeListener,
      }}>
      {props.children}
    </WebSocketContext.Provider>
  );
}

function useWebSocket() {
  const context = React.useContext(WebSocketContext);
  return (
    context || {
      addListener: () => {},
      removeListener: () => {},
    }
  );
}

export { useWebSocket, WebSocketContext };
